<template>
  <accordion-simple-item title="Produkt Felder" class="" :flex="true" v-if="userData?.isAdmin">
    <div class="flex flex-grow flex-col overflow-hidden h-full">

      <TRInput v-model="customFiledSearch" type="text" placeholder="Produktfeld..." class="p-2 w-full my-2"
               data-ui="input-search-product-field"></TRInput>
      <button class="p-1 bg-white mb-4 mt-2  w-full hover:bg-trader-blue hover:text-white"
              data-ui="button-create-new-product-field"
              @click="navigateTo(`/administration/${accordionIndex}/createCustomField`)">Neues Produktfeld erstellen
      </button>
      <div class=" overflow-y-auto " data-ui="productField-list">
        <div v-if="filteredProductCustomFields !== null" v-for="(customField, index) in  filteredProductCustomFields "
             :key="customField.idProductCustomField">
          <div class="w-full p-1  flex my-2 hover:bg-trader-blue hover:text-white "
               :class="{ 'bg-trader-blue text-white': idProductField == customField.idProductCustomField, 'bg-trader-dark-gray': idProductField != customField.idProductCustomField }"
               @click="navigateTo(`/administration/${accordionIndex}/product`, { productFieldId: customField.idProductCustomField})"
               :data-ui="'productField-' + customField.fieldName ">
                  <span class="w-full cursor-pointer">
                  {{ customField.fieldName }}
                 </span>
          </div>
        </div>
      </div>
    </div>

  </accordion-simple-item>
</template>

<script>
import TRInput from "@/components/Base/TRInput.vue";
import {mapState} from "vuex";
import AccordionItem from "@/components/Accordion/AccordionItem.vue";
import AccordionSimpleItem from "@/components/Accordion/AccordionSimpleItem.vue";
import router from "@/router";
import SignalBus from "@/application/SignalBus";
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";

export default {
  name: "SPurchaser",
  data() {
    return {
      customFiledSearch: '',
      productCustomFields: null,
      idProductField: 0,
    }
  },
  components: {
    AccordionSimpleItem,
    AccordionItem,
    TRInput,
  },
  props: {

    accordionIndex: {
      type: Number,
      default: () => {
      }
    },
  },
  computed: {
    ...mapState('user', ['userData']),
    filteredProductCustomFields() {
      if (!this.productCustomFields) {
        // Hier könnten Sie ein leeres Array zurückgeben oder eine andere Logik implementieren
        return [];
      }
      return this.productCustomFields.filter(customField => customField.fieldName.toLowerCase().includes(this.customFiledSearch.toLowerCase()));
    },
  },
  methods: {
    async getProductCustomFields() {
      try {
        const response = await apolloClient.query({
          query: gql`
            query getProductCustomFields {
              getProductCustomFields {
                idProductCustomField
                fieldName

              }
            }
          `
        });

        this.productCustomFields = response.data.getProductCustomFields;
      } catch (error) {
        console.error("Fehler beim Abrufen der getFormularNames:", error);
      }
    },
    navigateTo(route, params = {}) {
      let path = route;
      // Aufbau des Pfades basierend auf übergebenen Parametern
      if (Object.keys(params).length) {
        const paramParts = Object.keys(params).map(key => params[key]);
        path += '/' + paramParts.join('/');
      }
      router.push(path);
      if (route.includes('page')) {
        SignalBus.emit("sidebar-reload-project_date");
      }
      if (route.includes('template')) {
        this.pageTemplateId = params.templateId;
      }
    },
  },
  mounted() {
    this.getProductCustomFields();
    SignalBus.connect(this,"productFieldUpdated", this.getProductCustomFields);
  },
  beforeUnmount() {
     SignalBus.disconnectAllFromParent(this);
  },
  created() {
    this.idProductField =  this.$route.params.productFieldId
  },
  watch: {
    '$route.params.productFieldId': function (newId, oldId) {
      this.idProductField = newId;
      this.getProductCustomFields();
    },
  },
}
</script>